import React from 'react'
import Table, { TableProps } from 'antd/es/table'
import 'antd/es/table/style/css'
import { cx, css } from 'emotion'
import { BLACK } from 'src/constants/colors'
import { MAIN_FONT } from 'src/shared/TypographyStyles'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CustomTableProps = TableProps<any> & {
  className?: string
  emptyText?: React.ReactNode
}

const baseStyle = css`
  -webkit-font-smoothing: antialiased;
  font-family: ${MAIN_FONT};
  color: ${BLACK.DEFAULT};
`

const CustomTable = ({ className, emptyText, ...restProps }: CustomTableProps) => (
  <Table
    className={cx(baseStyle, className)}
    locale={{
      emptyText,
    }}
    {...restProps}
  />
)
export default CustomTable
